import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';
import { Col, Container, Image, Row } from 'react-bootstrap';
import styles from './addons.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
// import { OutlineButton } from 'components/Button';
import donations from 'assets/images/donations.png';

const FEATURE_DATA = [
  {
    id: 'CREATE & PUBLISH FUNDRAISING CAMPAIGNS',
    title: 'Setup your fundraising categories and goals via your Admin module.',
  },
  {
    id: 'REMINDER EMAILS',
    title:
      'Set email reminders to follow up and thank funders, or to request donations',
  },
  {
    id: 'ADD PAYMENT TRANSACTIONS',
    title:
      'Add transactions for up to two payment types and email receipts directly from the CAP60 database.',
  },
  {
    id: 'GOAL & PERCENTAGE CALCULATOR    ',
    title:
      'Keep track of Event Goals, Funding Sources, and Percentages Met.      ',
  },
  {
    id: 'FUNDER INFORMATION',
    title: 'Add individual funders and enter their personal information.',
  },
];
function CampaignManager() {
  return (
    <div>
      <Helmet>
        <title>Campaign Manager - CAP60</title>
        <meta
          name="description"
          content="Cap60s' campaign manager create & publish fundraising campaigns, set emil reminders, keep track of email goals. Contact us Now!."
        />
        <meta name="keyword" content="campaign manager" />
      </Helmet>
      <PageBanner
        title="Donor Manager"
        subtitle="Manage donations and donor contact lists."
      />
      <div className={styles.clientDeskWrapper}>
        <Container>
          <Row>
            <Col md="7">
              <div className="heading">
                <h2>CAP60 Donor Manager</h2>
              </div>
              <p>
                The Donor Manager allows for your agency to set up fundraising
                campaigns and track the progress of the event. The tool can
                connect to your agency’s PayPal account to allow for direct
                deposit.
              </p>
              <p>
                All donations are tracked through this tool. Contacts are
                maintained to provide a donor list for future fundraisers and
                events.
              </p>

              <RequestDemoButton />
            </Col>
            <Col md="5">
              <div className={styles.rightDark}>
                <Image height={300} src={donations} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="floralbg-blue">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="secondary"
            title="Features"
            itemsPerRow={4}
            itemClass={styles.featureItem}
          />
        </Container>
      </div>
    </div>
  );
}

export default CampaignManager;
